define('tokenstorage',[], function () {
   var token = undefined;
   
   var getToken = function () {
       return new Promise(function (resolve, reject) {
           if(typeof token !== "undefined") {
               resolve(token);
               return;
           }

           if(window.cordova && window.cordova.platformId === "ios") {
               // upgrade token from local storage to keychain
               var tokenForUpgrade = localStorage.getItem("VeggieZoneToken");
               if (tokenForUpgrade) {
                   token = tokenForUpgrade;
                   window.localStorage.removeItem("VeggieZoneToken");
                   setToken(token).then(function() { resolve(token )});
                   return;
               }
               
               // load token from keychain
               window.cordova.exec(function (keychainToken) {
                   console.log("Token loaded: " + keychainToken);
                   if(keychainToken != null) {
                       token = keychainToken;
                   } else {
                       token = null;
                   }
                   resolve(token);
               }, function (error) {
                   console.log("Error getting token: " + error);
                   token = null;
                   resolve(token);
               }, "VeggieZoneTokenStorage", "loadToken", []);
           } else {
               var localStorageToken = localStorage.getItem("VeggieZoneToken");
               if (localStorageToken) {
                   token = localStorageToken;
               } else {
                   token = null;
               }
               resolve(token);
           }
       });
   };
   
   var setToken = function (newToken) {
       token = newToken;

       return new Promise(function (resolve, reject) {
           if (window.cordova && window.cordova.platformId === "ios") {
               window.cordova.exec(function () {
                   console.log("Token saved: " + newToken);
                   resolve();
               }, function (error) {
                   console.log("Error saving token: " + error);
                   reject(error);
               }, "VeggieZoneTokenStorage", "saveToken", [newToken]);
           } else {
               localStorage.setItem("VeggieZoneToken", newToken);
               resolve();
           }
       });
   };
   
   return {
       getToken: getToken,
       setToken: setToken,
   } 
});
